import React, { useState } from "react";
import { URLS } from "../urls";
import { Form } from "react-bootstrap";
import { branch_id, maturityTime } from "../../utils";
import Select from "react-select";
import { toast } from "react-toastify";

export default function AddLeaveModal(props) {
  const [yearMonth, setYearMonth] = useState("");
  const [numberYearMonth, setNumberYearMonth] = useState("");
  const [prorated, setProrated] = useState(false);

  const [state, setState] = useState({
    buttonText: "Submit",
    isWaiting: false,
    leave: {
      name: "",
      days: 0,
      carry: false,
      carryMax: 0,
      earned: false,
      forGender: "ALL",
      isActive: false,
      customPolicies: [],
      branch_id,
      oldBranch: branch_id,
      duration: 0,
      branches: [
        {
          value: "all",
          label: "All Branches",
        },
      ],
    },
  });

  const updateLeaveName = (e) => {
    const { leave } = state;
    leave.name = e.target.value;
    setState((el) => ({
      ...el,
      leave,
    }));
  };
  // const updateLeaveDays = (e) => {
  //   const { leave } = state;
  //   leave.days = e.target.value;
  //   setState((el) => ({
  //     ...el,
  //     leave,
  //   }));
  // };
  // const updateLeaveCarryMax = (e) => {
  //   const { leave } = state;
  //   leave.carryMax = e.target.value;
  //   setState((el) => ({
  //     ...el,
  //     leave,
  //   }));
  // };
  // const updateLeaveIsActive = (e) => {
  //   const { leave } = state;
  //   leave.isActive = !leave.isActive;
  //   setState((el) => ({
  //     ...el,
  //     leave,
  //   }));
  // };
  const updateLeaveCarryForward = (e) => {
    const { leave } = state;
    leave.carry = !leave.carry;
    setState((el) => ({
      ...el,
      leave,
    }));
  };

  const updateLeaveExpire = (e) => {
    const { leave } = state;
    if (!leave.neverExpire) {
      leave.carry = false;
      leave.duration = 0;
    }
    leave.neverExpire = !leave.neverExpire;

    setState((el) => ({
      ...el,
      leave,
    }));
  };

  const updateLeaveProrated = (e) => {
    const { leave } = state;
    // if (!prorated) {
    //   // leave.carry = false;
    //   // leave.duration = 0;
    //   leave.neverExpire = true;
    // } else {
    //   leave.neverExpire = false;
    // }

    setProrated(!prorated);
    setState((el) => ({
      ...el,
      leave,
    }));
  };

  const updateLeaveBackDate = (e) => {
    const { leave } = state;
    leave.backDate = !leave.backDate;

    setState((el) => ({
      ...el,
      leave,
    }));
  };
  const updateLeaveForGender = (e) => {
    const { leave } = state;
    leave.forGender = e.target.value;
    setState((el) => ({
      ...el,
      leave,
    }));
  };

  const updateLeaveBranch = (e) => {
    const { leave } = state;
    leave.branches = e;
    setState((el) => ({
      ...el,
      leave,
    }));
  };
  const updateLeaveDuration = (e) => {
    const { leave } = state;
    leave.duration = e.target.value;
    setState((el) => ({
      ...el,
      leave,
    }));
  };

  const submit = (e) => {
    e.preventDefault();
    setState((el) => ({
      ...el,
      buttonText: "Submitting ...",
      isWaiting: true,
    }));
    const { leave } = state;
    //console.log(leave);

    leave.prorated = prorated;
    leave.yearMonth = yearMonth;
    leave.numberYearMonth = numberYearMonth;

    const token = "dummy token";
    fetch(`${URLS.backendLeaves}/add`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
      body: JSON.stringify({ leave }),
    }).then((res) => {
      if (res.ok) {
        res.json().then((result) => {
          window.$("#add_leave").modal("toggle");
          setState((el) => ({ ...el, buttonText: "Submit", isWaiting: false }));
          props.updateLeavesList(result.leave);
        });

        if (props?.reloadPage) {
          props.reloadPage();
        }
      } else {
        res.json().then((responseJson) => {
          console.log(responseJson);
          toast.error("Error occurred, Check the form again.");
          setState((el) => ({ ...el, buttonText: "Submit", isWaiting: false }));
        });
      }
    });
  };

  const { leave } = state;
  return (
    <div id="add_leave" className="modal custom-modal fade" role="dialog">
      <div
        className="modal-dialog modal-dialog-centered modal-lg"
        role="document"
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Add Leave</h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <form onSubmit={submit}>
              <div className="row">
                <div className="col-md-12">
                  <div className="form-group">
                    <label className="col-form-label">
                      Leave Type<span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      value={leave.name}
                      onChange={updateLeaveName}
                      required
                    />
                  </div>
                </div>
                {/* <div className="col-md-6">
                  <div className="form-group">
                    <label className="col-form-label">
                      Days<span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control"
                      type="number"
                      value={leave.days}
                      onChange={updateLeaveDays}
                      required
                    />
                  </div>
                </div> */}
                {!leave.neverExpire ? (
                  <div className="col-12">
                    <div className="row">
                      <div className="col-md-3">
                        <div className="form-group">
                          <label className="col-form-label">
                            Carry Forward<span className="text-danger">*</span>
                          </label>
                          <div
                            className="onoffswitch"
                            style={{ marginLeft: "0", marginRight: "auto" }}
                          >
                            <input
                              type="checkbox"
                              name="onoffswitch"
                              className="onoffswitch-checkbox"
                              id="switch_hospitalisation"
                              checked={leave.carry}
                            />
                            <label
                              className="onoffswitch-label"
                              for="switch_hospitalisation"
                              onClick={updateLeaveCarryForward}
                            >
                              <span className="yesnoswitch-inner"></span>
                              <span className="onoffswitch-switch"></span>
                            </label>
                          </div>
                        </div>
                      </div>
                      {leave.carry && (
                        <>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label className="col-form-label">
                                Duration after leave year
                              </label>
                              <Form.Control
                                as="select"
                                name="duration"
                                value={leave.duration}
                                onChange={updateLeaveDuration}
                                required
                              >
                                <option value="">Select Month</option>
                                {[...Array(12)].map((e, index) => (
                                  <option key={index}>{index + 1}</option>
                                ))}
                              </Form.Control>
                            </div>
                          </div>

                          <div lassName="col-md-2">
                            <label className="col-form-label"></label>
                            <div className="mt-4">
                              <h4>Month(s)</h4>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                ) : null}
                {!prorated ? (
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="col-form-label">Never Expire</label>
                      <div
                        className="onoffswitch"
                        style={{ marginLeft: "0", marginRight: "auto" }}
                      >
                        <input
                          type="checkbox"
                          name="onoffswitch"
                          className="onoffswitch-checkbox"
                          id="switch_hospitalisation"
                          checked={leave.neverExpire}
                        />
                        <label
                          className="onoffswitch-label"
                          for="switch_hospitalisation"
                          onClick={updateLeaveExpire}
                        >
                          <span className="yesnoswitch-inner"></span>
                          <span className="onoffswitch-switch"></span>
                        </label>
                      </div>
                    </div>
                  </div>
                ) : null}
                <div className="col-md-6">
                  <div className="form-group">
                    <label className="col-form-label">
                      Available for Gender
                    </label>
                    <Form.Control
                      as="select"
                      name="department"
                      value={leave.forGender}
                      onChange={updateLeaveForGender}
                      required
                    >
                      <option value="ALL">All</option>
                      <option value="MALE">Male</option>
                      <option value="FEMALE">Female</option>
                    </Form.Control>
                  </div>
                </div>
                {/* <div className="col-md-6">
                  <div className="form-group">
                    <label className="col-form-label">
                      is available for Employees
                    </label>
                    <div
                      className="onoffswitch"
                      style={{ marginLeft: "0", marginRight: "auto" }}
                    >
                      <input
                        type="checkbox"
                        name="onoffswitch"
                        className="onoffswitch-checkbox"
                        id="switch_hospitalisation"
                        checked={leave.isActive}
                      />
                      <label
                        className="onoffswitch-label"
                        for="switch_hospitalisation"
                        onClick={updateLeaveIsActive}
                      >
                        <span className="yesnoswitch-inner"></span>
                        <span className="onoffswitch-switch"></span>
                      </label>
                    </div>
                  </div>
                </div> */}
                <div className="col-md-12">
                  <div className="form-group">
                    <label className="col-form-label">Select Company</label>

                    <Select
                      closeMenuOnSelect={true}
                      isMulti
                      isSearchable={true}
                      value={
                        leave?.branches?.length
                          ? props.branches?.filter((d) =>
                              leave?.branches?.find((e) => e.value === d.value)
                            )
                          : []
                      }
                      onChange={(selected) => {
                        updateLeaveBranch(selected);
                      }}
                      options={props.branches}
                    />
                  </div>
                </div>
                <div className="col-12">
                  <p>Maturity period from joined date </p>

                  <div className="row">
                    <div className="col-md-4">
                      <label>Number of months/years:</label>
                      <input
                        type="number"
                        placeholder="Number of months/years"
                        value={numberYearMonth}
                        className="form-control"
                        onChange={(e) => setNumberYearMonth(e.target.value)}
                      />
                    </div>
                    <div className="col-md-4">
                      <label>Month/Year:</label>
                      <select
                        className="form-control"
                        aria-label="Default select example"
                        value={yearMonth}
                        onChange={(e) => setYearMonth(e.target.value)}
                      >
                        {maturityTime.map((a, i) => (
                          <option key={i} value={a.value}>
                            {a.label}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-md-4">
                      <div className="form-group">
                        <label className="col-form-label">Prorated</label>
                        <div
                          className="onoffswitch"
                          style={{ marginLeft: "0", marginRight: "auto" }}
                        >
                          <input
                            type="checkbox"
                            name="onoffswitch"
                            className="onoffswitch-checkbox"
                            id="switch_hospitalisation"
                            checked={prorated}
                          />
                          <label
                            className="onoffswitch-label"
                            for="switch_hospitalisation"
                            onClick={updateLeaveProrated}
                          >
                            <span className="yesnoswitch-inner"></span>
                            <span className="onoffswitch-switch"></span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-group">
                    <label className="col-form-label">Allow Backdate</label>
                    <div
                      className="onoffswitch"
                      style={{ marginLeft: "0", marginRight: "auto" }}
                    >
                      <input
                        type="checkbox"
                        name="onoffswitch"
                        className="onoffswitch-checkbox"
                        id="switch_hospitalisation"
                        checked={leave.backDate}
                      />
                      <label
                        className="onoffswitch-label"
                        for="switch_hospitalisation"
                        onClick={updateLeaveBackDate}
                      >
                        <span className="yesnoswitch-inner"></span>
                        <span className="onoffswitch-switch"></span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <div className="submit-section">
                <button className="btn add-btn">{state.buttonText}</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
